var en_IND = {};
module['exports'] = en_IND;
en_IND.title = "English (India)";
en_IND.name = require("./name");
en_IND.address = require("./address");
en_IND.internet = require("./internet");
en_IND.company = require("./company");
en_IND.phone_number = require("./phone_number");
